import React from 'react';
import { observer } from 'mobx-react';
import { ScrollView, StackLayout } from '@wemogy/reactbase';
import RoleListItem from '../roleListItem/RoleListItem';
var RoleList = function (_a) {
    var roles = _a.roles;
    return (React.createElement(ScrollView, { minHeight: 40 },
        React.createElement(StackLayout, null, roles.map(function (role) { return (React.createElement(RoleListItem, { key: role.id, role: role })); }))));
};
export default observer(RoleList);
//# sourceMappingURL=RoleList.js.map